import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom'
import './index.css';
import App from './App';
import {CookiesProvider} from 'react-cookie';
import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';

ReactDOM.render(
    <CookiesProvider>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </CookiesProvider>
    , document.getElementById('root')
);
